// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app {\n  overflow: hidden;\n  height: 100%;\n}\n/deep/ .ant-input[disabled] {\n  color: deepskyblue;\n  background-color: #fff;\n  border: 0;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: not-allowed;\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
